<template>
  <div
    class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
    @click="visitMembershipGroupDetails"
  >
    <div class="card card-bio-content card--interactive text-center">
      <h6
        class="text-blue uppercase -mt-2 mb-4"
        v-text="membershipGroup.attributes.type"
      />
      <h2
        class="mb-1"
        v-text="membershipGroup.attributes.title"
      />
      <p
        class="italic"
        v-text="membershipGroup.attributes.description"
      />
      <small
        v-if="membershipGroup.attributes.self_assignable"
        v-can="'edit-membership-groups'"
        v-text="'Self-Assignable'"
      />
      <h5
        class="mt-0 mb-4 uppercase"
        v-text="membershipCount"
      />
      <a
        v-can="'edit-membership-groups'"
        class="btn btn--sm btn--icon-only icon icon--small"
        href="#"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="15"
          viewBox="0 0 9 15"
        >
          <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'MembershipGroup',
  props: {
    membershipGroup: {
      type: Object,
      required: true,
    },
  },
  computed: {
    membershipCount() {
      return this.membershipGroup.attributes.membership_count === 1
        ? '1 member'
        : `${this.membershipGroup.attributes.membership_count} members`
    },
  },
  methods: {
    visitMembershipGroupDetails() {
      window.location = this.$urlGenerator.active(`members/membership-groups/${this.membershipGroup.uuid}`)
    },
  },
}
</script>
